export default function AccordionArrow({ width = 15, height = 9, className, style }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 15 9"
            fill="none"
            className={className}
            style={style}
            aria-hidden="true"
        >
            <path
                d="M7.09583 8.1875C6.92613 8.1875 6.76194 8.15625 6.60326 8.09375C6.44374 8.03125 6.31094 7.94791 6.20488 7.84375L0.350019 2.09375C0.116673 1.86458 2.75017e-07 1.57292 2.13093e-07 1.21875C1.51168e-07 0.864582 0.116673 0.572916 0.350018 0.343749C0.583364 0.114583 0.88035 -1.53925e-07 1.24098 -2.16979e-07C1.6016 -2.80033e-07 1.89859 0.114582 2.13193 0.343749L7.09583 5.21875L12.0597 0.343747C12.2931 0.114581 12.5901 -2.20132e-06 12.9507 -2.26437e-06C13.3113 -2.32742e-06 13.6083 0.11458 13.8416 0.343747C14.075 0.572914 14.1917 0.86458 14.1917 1.21875C14.1917 1.57291 14.075 1.86458 13.8416 2.09375L7.98679 7.84375C7.85951 7.96875 7.72163 8.05708 7.57313 8.10875C7.42464 8.16125 7.26554 8.1875 7.09583 8.1875Z"
                fill="#EAEAEA"
            />
        </svg>
    );
}
